import _isNil from 'lodash/isNil';
import { BOOKABLE_STATUS_ICON_TYPES } from 'components/ClassesList/ClassesList.helpers';
import {
  RETAIL_RATE_REQUEST_STATUS,
  RETAIL_RATE_REQUEST_STATUS_REASON,
  getRejectedRetailRateRequestTooltipKey,
  getRetailRateRequestStatus,
  getRetailRateRequestStatusReason,
  isRetailRateRequestPending,
  isRetailRateRequestRejected,
} from 'features/ManageServices/Components/ServicePricingSection/pricingStatusStepper.helpers';

const APPROVED_WITH_CHANGES_STATUSES = new Set(['approved_rate_change', 'approved_with_rate_change']);

const isRetailRateRequestApproved = retailRateRequest =>
  getRetailRateRequestStatus(retailRateRequest) === RETAIL_RATE_REQUEST_STATUS.APPROVED;

// Same derivation as the edit-page stepper: approved with a rate-change reason
// means "available with changes".
const isApprovedWithRateChange = retailRateRequest =>
  isRetailRateRequestApproved(retailRateRequest) &&
  getRetailRateRequestStatusReason(retailRateRequest) === RETAIL_RATE_REQUEST_STATUS_REASON.RATE_CHANGES_NEEDED;

export function getManualBookableStatusDisplay({ disabled, retailRateRequest, price, status, classPricingRule } = {}) {
  const pricingStatus = status ?? classPricingRule?.status;

  if (disabled || pricingStatus === 'disabled') {
    return {
      messageKey: 'disabled',
      iconType: BOOKABLE_STATUS_ICON_TYPES.GREY_DOT,
      tooltipMessageKey: null,
    };
  }

  if (isRetailRateRequestRejected(retailRateRequest)) {
    return {
      messageKey: 'actionRequired',
      iconType: BOOKABLE_STATUS_ICON_TYPES.ACTION_ALERT,
      tooltipMessageKey: getRejectedRetailRateRequestTooltipKey(retailRateRequest),
    };
  }

  if (isRetailRateRequestPending(retailRateRequest) || _isNil(price)) {
    return {
      messageKey: 'pendingReview',
      iconType: BOOKABLE_STATUS_ICON_TYPES.PENDING,
      tooltipMessageKey: 'pendingReviewTooltip',
    };
  }

  if (isApprovedWithRateChange(retailRateRequest) || APPROVED_WITH_CHANGES_STATUSES.has(pricingStatus)) {
    return {
      messageKey: 'availableWithChanges',
      iconType: BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT,
      tooltipMessageKey: null,
    };
  }

  if (isRetailRateRequestApproved(retailRateRequest) || pricingStatus === 'approved') {
    return {
      messageKey: 'available',
      iconType: BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT,
      tooltipMessageKey: null,
    };
  }

  return {
    messageKey: 'enabled',
    iconType: BOOKABLE_STATUS_ICON_TYPES.GREEN_DOT,
    tooltipMessageKey: null,
  };
}
